// actions/userActions.js

import { MARK_REFERRAL_DISCOUNT_USED } from "./actionTypes";
import LocalStorageService from "../../services/LocalStorageService";

export const markReferralDiscountUsed = () => (dispatch) => {
  const service = LocalStorageService.getService();
  service.updateReferralDiscountFlag(true);

  dispatch({
    type: MARK_REFERRAL_DISCOUNT_USED,
  });
};
